// INHERTA marks — GENERATED by scripts/generate-brand-marks.mjs from
// packages/web/public/brand/*.svg. Do not edit by hand; edit the SVGs and
// re-run the script.
//
// Inline SVG rather than <img>: the letterforms are `currentColor`, which is
// what makes one component white on the always-dark nav rail and black on a
// light surface. The A keeps the brand blue in both — that two-tone treatment
// is the identity, and the A is the isotipo doing double duty as a letter.
//
// Size these with a height class on the component itself. They carry a viewBox
// and no width/height so the width follows the aspect ratio, which also means
// a sized WRAPPER does nothing and the mark collapses to zero.

/** Full INHERTA wordmark as inline SVG: letters follow `currentColor`, the A
 *  stays brand blue in both themes. Size with a height class on the component
 *  itself — sizing a wrapper does nothing and the mark collapses to zero. */
export function InhertaWordmark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 1691.39 185.09" role="img" aria-label="INHERTA" className={className}>
      <path fill="currentColor" d="M 0 0 L 29.09 0 L 29.09 185.09 L 0 185.09 Z M 0 0 " />
      <path
        fill="currentColor"
        d="M 127.7 185.09 L 127.7 0 L 155.99 0 L 272.11 117.73 C 274.08 119.54 276.42 121.91 279.11 124.88 C 281.81 127.84 284.54 130.76 287.33 133.63 C 290.11 136.51 292.49 139.11 294.47 141.45 L 296.63 141.45 C 296.45 138.04 296.31 133.77 296.22 128.65 C 296.13 123.53 296.09 118.99 296.09 115.04 L 296.09 0 L 324.38 0 L 324.38 185.09 L 297.43 185.09 L 180.78 66.28 C 176.64 62.15 172.38 57.7 167.98 52.94 C 163.57 48.18 160.12 44.37 157.61 41.49 L 155.72 41.49 C 155.72 44.55 155.76 48.9 155.86 54.56 C 155.95 60.21 155.99 65.92 155.99 71.67 L 155.99 185.09 Z M 127.7 185.09 "
      />
      <path
        fill="currentColor"
        d="M 422.98 185.09 L 422.98 0 L 452.07 0 L 452.07 77.59 L 590.29 77.59 L 590.29 0 L 619.65 0 L 619.65 185.09 L 590.29 185.09 L 590.29 103.46 L 452.07 103.46 L 452.07 185.09 Z M 422.98 185.09 "
      />
      <path
        fill="currentColor"
        d="M 747.09 78.13 L 884.76 78.13 L 884.76 102.92 L 747.09 102.92 L 747.09 160.3 L 902.27 160.3 L 902.27 185.09 L 717.99 185.09 L 717.99 78.18 M 717.99 25.05 L 717.99 0 L 900.12 0 L 900.12 25.05 L 747.09 25.05 "
      />
      <path
        fill="currentColor"
        d="M 1021.62 88.1 L 1124.54 88.1 C 1134.95 88.1 1143.04 85.14 1148.79 79.21 C 1154.53 73.28 1157.41 65.56 1157.41 56.04 C 1157.41 49.75 1156.1 44.28 1153.5 39.61 C 1150.89 34.94 1147.17 31.35 1142.32 28.83 C 1137.47 26.32 1131.55 25.06 1124.54 25.06 L 992.52 25.06 L 992.52 0 L 1131.55 0 C 1143.75 0 1154 2.47 1162.25 7.41 C 1170.52 12.35 1176.71 19.04 1180.85 27.48 C 1184.98 35.93 1187.05 45.36 1187.05 55.77 C 1187.05 67.27 1184.08 77.68 1178.15 87.02 C 1172.23 96.36 1163.42 103.28 1151.75 107.77 L 1191.89 185.09 L 1159.02 185.09 L 1122.39 112.89 L 1021.62 112.89 L 1021.62 185.09 L 992.52 185.09 L 992.52 88.1 Z M 1021.62 88.1 "
      />
      <path
        fill="currentColor"
        d="M 1335.5 185.09 L 1335.5 25.87 L 1251.97 25.87 L 1251.97 0 L 1448.65 0 L 1448.65 25.87 L 1364.86 25.87 L 1364.86 185.09 Z M 1335.5 185.09 "
      />
      <path
        fill="#0a68ff"
        d="M 1624.85 117.2 L 1620 107.46 L 1597.64 62.51 C 1596.56 60.35 1595.21 57.52 1593.59 54.02 C 1591.98 50.52 1590.32 46.84 1588.61 42.97 C 1586.9 39.11 1585.29 35.61 1583.76 32.46 C 1582.23 29.32 1581.11 27.13 1580.39 25.87 L 1578.24 25.87 C 1576.44 29.64 1574.42 33.95 1572.18 38.8 C 1569.93 43.65 1567.82 48.23 1565.84 52.54 C 1563.86 56.85 1562.25 60.18 1561 62.51 L 1535.9 112.45 L 1519.65 145.42 L 1499.57 185.09 L 1469.13 185.09 L 1563.15 0 L 1597.09 0 L 1691.39 185.09 L 1659.06 185.09 L 1638.69 144.84 L 1636.97 141.45 Z M 1624.85 117.2 "
      />
    </svg>
  )
}

/** The isotipo alone — the A of the wordmark, for slots too tight for words. */
export function InhertaIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 905.95 754.41" role="img" aria-label="INHERTA" className={className}>
      <path
        fill="#0a68ff"
        d="M 634.71 477.69 L 614.97 438 L 523.81 254.77 C 519.41 245.98 513.93 234.45 507.33 220.18 C 500.74 205.9 493.96 190.91 487.01 175.15 C 480.04 159.42 473.46 145.14 467.25 132.33 C 461.02 119.53 456.43 110.55 453.52 105.43 L 444.74 105.43 C 437.41 120.8 429.18 138.37 420.03 158.13 C 410.87 177.9 402.27 196.57 394.21 214.14 C 386.15 231.71 379.57 245.27 374.45 254.77 L 272.16 458.36 L 205.93 592.71 L 124.07 754.41 L 0 754.41 L 383.24 0 L 521.6 0 L 905.95 754.41 L 774.17 754.41 L 691.12 590.35 L 684.12 576.52 Z M 634.71 477.69 "
      />
    </svg>
  )
}
